import $ from "jquery";
import { ck, URLS } from "fire-wind-water";
import { $subscriber } from "fire-wind-water";
import webinarService from "../services/webinar";
import URL from "../assets/conf/setting";
import { socketModule } from "./socket";
let customFormId = URLS.getURL("customFormId");
let markCode = URLS.getURL("markCode");
let tc = URLS.getURL("tc");
let isMobile = !!navigator.userAgent.match(
  /(iPhone|iPod|Android|ios|HarmonyOS|OpenHarmony)/i
);
let userInfo = {};
let webinarInfo = {};
export default {
  userLoad(webinar) {
    webinarInfo = webinar;
    let defer = $.Deferred();
    userInfo.temporaryUserName =
      ck.cookie("temporaryUserName_" + webinarInfo.webinarId) || "";
    userInfo.cookie = ck.cookie("smarketMember_" + webinarInfo.schemaId);
    if (userInfo.cookie != "" && userInfo.cookie != null) {
      userInfo.isLogin = true;
      userInfo.session = userInfo.cookie.session;
    } else {
      userInfo.isLogin = false;
      userInfo.session = "";
    }
    let registrationInfo = ck.cookie(
      "registrationMember_" + webinarInfo.webinarId
    );
    //获取微信信息
    var tokenInfo = ck.cookie("verifyInfo_" + webinar.weChatId);
    if (tokenInfo) {
      userInfo.nickName = tokenInfo.nickname;
      userInfo.avatar = tokenInfo.avatar;
      userInfo.openId = tokenInfo.original.openid;
    }

    if (registrationInfo != null) {
      //  发送广播消息 参会人的信息
      this.setUserInfo(registrationInfo);
      //user
      ck.cookie("registrationMember_" + webinarInfo.webinarId, null, {
        domain: window.$sk.config.domain,
        path: "/"
      }); //清空报名信息cookie

      defer.resolve(userInfo);
    } else {
      if (userInfo.isLogin) {
        webinarService
          .getMemberContacts({
            tenantId: webinarInfo.tenantId,
            webinarId: webinarInfo.webinarId,
            sess: userInfo.session,
            isTemplate: 1,
            schemaId: webinarInfo.schemaId
          })
          .subscribe(data => {
            if (data.result == "0") {
              if (!userInfo.avatar) {
                if (
                  data.content.bindInfo &&
                  data.content.bindInfo.wechat &&
                  data.content.bindInfo.wechat.headImgUrl
                ) {
                  userInfo.avatar = data.content.bindInfo.wechat.headImgUrl;
                } else if (data.content.headImgUrl) {
                  userInfo.avatar = data.content.headImgUrl;
                }
              }
              userInfo.userName = data.content.name;
              $subscriber.emit("setUserName", data.content.name);
            } else {
              ck.cookie("smarketMember_" + webinarInfo.schemaId, null, {
                domain: window.$sk.config.domain,
                path: "/"
              });
            }
          });
      }

      webinarService
        .getContacts({
          tenantId: webinarInfo.tenantId,
          webinarId: webinarInfo.webinarId,
          sess: webinarInfo.unLimit
            ? ""
            : userInfo.cookie
            ? userInfo.cookie.session
            : "",
          openId: webinarInfo.unLimit ? "" : userInfo.openId || "",
          globalUserId: ck.cookie("globalUserId")
        })
        .subscribe(data => {
          //发送通知 用户信息
          this.setUserInfo(data.content);
          $subscriber.emit("onUnLimitRegistration", userInfo);

          userInfo.isShow = true;

          if (
            !webinarInfo.isClosed &&
            webinarInfo.isReleased &&
            !userInfo.isRegistration
          ) {
            if (
              (!webinarInfo.needRegistration && userInfo.isLogin) ||
              webinarInfo.unLimit
            ) {
              return this.silentSignUp(webinarInfo, userInfo).then(
                () => {
                  defer.resolve(userInfo);
                },
                () => {
                  defer.reject({
                    desc: "静默报名失败"
                  });
                }
              );
            } else {
              defer.resolve(userInfo);
            }
          } else {
            defer.resolve(userInfo);
          }
        });
    }
    return defer.promise();
  },
  setUserInfo(user) {
    if (user) {
      userInfo.id = user.signUpId;
      userInfo.memberId = user.signUpId;
      userInfo.applicantId = user.signUpId;
      userInfo.uid = (1000000000 + parseInt(user.signUpId)).toString();
      userInfo.isRegistration = parseInt(user.isSignUp) === 1;
      userInfo.hasPermission = parseInt(user.permission) === 1;
      userInfo.permission = user.permission;
      userInfo.isDelete = parseInt(user.isDelete) === 1;
      if (user.contact) {
        var mobile = user.contact.mobile
          ? this.encryptUserInfo(user.contact.mobile.toString(), "mobile")
          : null;
        var userName =
          !user.isUnLimit &&
          !user.contact.name &&
          !user.contact.mobile &&
          !user.contact.email
            ? "****"
            : null;
        userInfo.name =
          user.contact.name ||
          userInfo.nickName ||
          mobile ||
          this.encryptUserInfo(user.contact.email, "email") ||
          userName ||
          userInfo.temporaryUserName ||
          "匿名用户_" + userInfo.id;
        userInfo.email = user.contact.email;
        userInfo.mobile = user.contact.mobile;
        userInfo.company = user.contact.enterprise;
        userInfo.position = user.contact.position;
      }
      userInfo.channel = user.channel;
      userInfo.clientType = isMobile ? "mobile" : "pc";
      //（0：否， 1：是）
      userInfo.isUnLimit = user.isUnLimit;
      userInfo.markCode = user.markCode;
    } else {
      userInfo.isRegistration = false;
      userInfo.hasPermission = false;
      userInfo.isDelete = false;
    }
  },
  silentSignUp(webinar, user) {
    var defer = $.Deferred();
    /** 检查是否报名 */
    this.checkRegistration(webinar, user)
      .then(data => {
        return this.gotoSilentSignUp(webinar, user, data);
      })
      .then(data => {
        //会议是无限制观看的时候 不再去拿人的信息
        if (webinar.unLimit) {
          let obj = {
            permission: 1,
            isDelete: 0,
            signUpId: data.content.signUpId,
            isUnLimit: 1,
            isFrozen: 1,
            formData: null
          };
          this.setUserInfo(obj);
        } else {
          return this.userLoad(webinarInfo);
        }
      })
      .then(
        data => {
          defer.resolve(data);
        },
        error => {
          defer.reject(error);
        }
      );

    return defer.promise();
  },
  checkRegistration(webinar, user) {
    var defer = $.Deferred();
    /** 检查是否报名 */
    webinarService
      .checkRegistration({
        customFormId: customFormId,
        cookieId: ck.cookie("globalUserId"),
        instanceId: webinar.instanceId,
        openId: user.openId || "",
        sess: user.cookie ? user.cookie.session : "",
        includeFormData: 1,
        tenantId: webinar.tenantId
      })
      .subscribe(data => {
        defer.resolve(data);
      });
    return defer.promise();
  },
  gotoSilentSignUp(webinar, user, data) {
    var defer = $.Deferred();
    /** 检查是否报名 */
    const params = {
      webinarId: URLS.getURL("webinarId"),
      moduleId: 2,
      tenantId: webinar.tenantId,
      formId: webinar.isSilent ? customFormId : 0,
      channel: tc || "",
      globalUserId: ck.cookie("globalUserId"),
      weChatId: webinar.weChatId || "",
      openId: webinar.unLimit ? "" : user.openId || "",
      sess: webinar.unLimit ? "" : user.cookie ? user.cookie.session : "",
      isPreview: "0",
      signUpSource: isMobile ? "WAP" : "PC",
      isUnLimit: webinar.unLimit ? 1 : 0, //无限制观看静默报名 1 是 0 否
      // markCode 与 marketingSess 为用于统计的埋点相关参数
      markCode: markCode || "",
      markType: URLS.getURL("markType") || "",
      //      _isAsync: true, //只应用于无限制观看下的静默报名
      marketingSess: ck.cookie("marketingSess") || ""
    };
    if (data.content.formData && data.content.formData.length > 0) {
      params.formData = data.content.formData;
    }
    webinarService.silentSignUp(params).subscribe(data => {
      defer.resolve(data);
    });
    return defer.promise();
  },
  encryptUserInfo(val, type) {
    let encryptor = {
      email: function(val) {
        let prefix = val.replace(/^(.*)@.*$/, "$1");
        if (prefix.length < 5) {
          return val.replace(/^[^@]*@(.*)$/, "****@$1");
        }
        return val.replace(/^(\w{2}).*(\w{2})@(.*)$/, "$1****$2@$3");
      },
      qq: function(val) {
        if (val.length < 4) {
          return val[0] + "****";
        }
        return val.replace(/^(\d{2})\d+(\d{2})$/, "$1****$2");
      },
      mobile: function(val) {
        if (val.length !== 11) {
          return val.replace(/^(.*)([\w]{4})$/, "****$2");
        }
        return val.replace(/^(\w{3})\w{4}(\w{4})$/, "$1****$2");
      }
    };

    if (!encryptor[type]) {
      return;
    }
    if (!val) {
      return;
    }
    return encryptor[type](val);
  },
  //判断用户是否可以参会
  userCanJoin() {
    if (userInfo.isRegistration) {
      //有没有报过名
      socketModule.init(URL.webinarbInteractUrl + "center", null);
      socketModule.connect(userInfo, webinarInfo);
    }
  }
};
